module.exports = __webpack_public_path__ + "static/img/zz_jianshu_ficon.51f3c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zz_jianshu_ficon.png
// module id = 3/Rv
// module chunks = 1